module.exports = __webpack_public_path__ + "media/entities/1011-39695b2d.png";